import apiCall from "./apiCall";

const getMenus = async () => {
    const URL = '/Menus/GetMenus';
    return apiCall('get', URL);
};

export {
    getMenus
};
